import { Grid, Typography } from "@material-ui/core";
import moment from "moment";
import React, { FunctionComponent, useState } from "react";
import { useBillStyles } from "./useBillStyles";


type WithBillCreditCustomerDetailsProps = {
    billDetails: any;
    creditCustomerAvailable: boolean
    creditCustomerDetails: Array<object>;
    arabicDetails: any;
};

export const BillInvoiceDetails: FunctionComponent<WithBillCreditCustomerDetailsProps> = ({
    billDetails,
    creditCustomerAvailable,
    creditCustomerDetails,
    arabicDetails
}) => {

    const [arabicDescription, setArabicDescription] = useState<any>(arabicDetails)
    const classes = useBillStyles();

    return (
        <div>
            <Grid
                container
                direction="row"
            // justify="flex-start"
            >
                <Grid item xs={6}></Grid>
                <Grid item xs={6}
                    style={{ paddingBottom: "1em" }}
                >
                    <Typography
                        className={classes.billInvoiceDetailsHeadingStyle}
                    >
                        {creditCustomerAvailable ? "CREDIT INVOICE" : "INVOICE"}

                    </Typography>
                    <Typography
                        className={classes.billInvoiceDetailsStoreNameStyle}
                    >
                        {billDetails && billDetails.find((a: any) => a.store_name) !== undefined ?
                            billDetails && billDetails.find((a: any) => a).store_name
                            : ""}
                    </Typography>
                    {/* <Typography style={{ textAlign: "left",paddingLeft:"1em",fontSize: "2em", fontWeight: "bold" }}>
                        {
                            arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_CREDIT_INVOICE") !== undefined ?
                                arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_CREDIT_INVOICE").arabic_name : ""
                        }
                    </Typography> */}
                </Grid>

                <Grid item xs={6}>
                    <Grid container spacing={2}
                    justify="flex-start">
                        <Grid item  >
                            <Typography
                                className={classes.billInvoiceDetailsLeftKeyStyle}
                            >
                                Doc No
                          </Typography>
                        </Grid>
                        <Grid item  >
                            <Typography
                                className={classes.billInvoiceDetailsLeftDescriptionStyle}
                            >
                                :{" "}
                                {billDetails && billDetails.find((a: any) => a.bill_doc_number) !== undefined ?
                                    billDetails && billDetails.find((a: any) => a).bill_doc_number
                                    : ""}</Typography>

                        </Grid>
                        {/* <Grid item xs >
                                <Typography
                                     className={classes.billInvoiceDetailsDescriptionStyle}
                                >
                                    :{" "}{" "}{arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_DOC_NO") !== undefined ?
                                        arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_DOC_NO").arabic_name : ""}
                                </Typography>
                            </Grid> */}
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <Grid container 
                   // spacing={9} 
                    justify="flex-end">
                        <Grid item  >
                            <Typography
                                className={classes.billInvoiceDetailsRightKeyStyle}
                            >
                                Date
                          </Typography>
                        </Grid>
                        <Grid item  >
                            <Typography
                                className={classes.billInvoiceDetailsRightDescriptionStyle}
                            >
                                :{" "}
                                {billDetails && billDetails.find((a: any) => a.updated_at) !== undefined ?
                                moment((billDetails && billDetails.find((a: any) => a.updated_at).updated_at)).format("DD/MM/YYYY HH:mm:ss") : ""}
                            </Typography>

                        </Grid>
                        {/* <Grid item xs >
                                <Typography
                                     className={classes.billInvoiceDetailsDescriptionStyle}
                                >
                                   :{" "}{" "}{arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_DATE") !== undefined ?
                              arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_DATE").arabic_name : ""}
                                    </Typography>
                            </Grid> */}
                    </Grid>
                </Grid>
                {creditCustomerAvailable ?
                    <Grid item xs={6}>
                        <Grid container //spacing={1} 
                        justify="flex-start"
                        >
                            <Grid item  >
                                <Typography
                                    className={classes.billInvoiceDetailsLeftKeyStyle}
                                >
                                    Customer
                          </Typography>
                            </Grid>
                            <Grid item  >
                                <Typography
                                    className={classes.billInvoiceDetailsLeftDescriptionStyle}
                                >
                                    :{" "}
                                    {creditCustomerDetails.map((i: any) => i.customer_name)}</Typography>

                            </Grid>
                            {/* <Grid item xs >
                                <Typography
                                     className={classes.billInvoiceDetailsDescriptionStyle}
                                >
                                   :{" "}{" "}{arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_CUSTOMER") !== undefined ?
                              arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_CUSTOMER").arabic_name : ""}
                                    </Typography>
                            </Grid> */}
                        </Grid>
                    </Grid>
                    :
                    <Grid item xs={6}></Grid>
                }

                {creditCustomerAvailable ?
                    <Grid item xs={6}>
                        <Grid container //spacing={1}
                        justify="flex-end">
                            <Grid item  >
                                <Typography
                                    className={classes.billInvoiceDetailsRightKeyStyle}
                                >
                                    Credit Balance
                          </Typography>
                            </Grid>
                            <Grid item  >
                                <Typography
                                    className={classes.billInvoiceDetailsRightDescriptionStyle}
                                >
                                    :{" "}
                                    {creditCustomerDetails.map((i: any) => i.credit_amount_balance)}</Typography>

                            </Grid>
                        </Grid>
                    </Grid>
                    :
                    <Grid item xs={6}></Grid>
                }



            </Grid>
        </div>
    );
}